import {
    CreateTicketFormValues,
    EditTicketFormValues,
    EndUserRequestFormValues,
    PublicVisibleTypeMap
} from '../../../types/form';
import {
    AuxGrispiFormItemsName,
    TICKET_FORM_FIELDS_KEY,
    TicketSystemFieldsKey,
    TicketSystemFieldsKeyMap,
    channelTypeMap,
    reverseStatusMap
} from '../../model/types';
import { publicVisibleToBooleanConverter } from '../../utils/forms/formHelper.parser';
import { FormSystemFields } from '../../utils/forms/formHelpers';

const basicDefaultValues = {
    [AuxGrispiFormItemsName.comment]: null,
    [FormSystemFields.name]: {
        [TicketSystemFieldsKey.subject]: ''
    }
};

export const baseinitialCreateTicketValues = {
    ...basicDefaultValues,
    [AuxGrispiFormItemsName.activeForm]: 1,
    [AuxGrispiFormItemsName.channel]: channelTypeMap.WEB,
    [AuxGrispiFormItemsName.distributionListTo]: null,
    [FormSystemFields.name]: {
        ...basicDefaultValues[FormSystemFields.name],
        [TicketSystemFieldsKey.status]: reverseStatusMap.New
    }
};

export const baseInitialEditTicketValues = {
    ...basicDefaultValues
};

export const createTicketDefaultValues: Omit<CreateTicketFormValues, 'formName'> = {
    comment: {
        body: null,
        channel: channelTypeMap.WEB,
        publicVisible: publicVisibleToBooleanConverter(PublicVisibleTypeMap.internal),
        creator: [
            {
                key: 'us.id',
                value: null
            }
        ]
    },
    currentAttachments: { inlineImages: [], attachments: [] },
    [TICKET_FORM_FIELDS_KEY]: {
        [TicketSystemFieldsKeyMap.emailCc]: null,
        [TicketSystemFieldsKeyMap.status]: reverseStatusMap.New,
        [TicketSystemFieldsKeyMap.subject]: null,
        [TicketSystemFieldsKeyMap.requester]: null,
        [TicketSystemFieldsKeyMap.assignee]: null,
        [TicketSystemFieldsKeyMap.creator]: null,
        [TicketSystemFieldsKeyMap.formId]: null
    }
};

export const editTicketDefaultValues: Omit<EditTicketFormValues, 'formName' | 'channel'> = {
    comment: {
        body: null,
        channel: channelTypeMap.WEB,
        creator: [
            {
                key: 'us.id',
                value: null
            }
        ],
        publicVisible: publicVisibleToBooleanConverter(PublicVisibleTypeMap.internal)
    },
    currentAttachments: { inlineImages: [], attachments: [] },
    [TICKET_FORM_FIELDS_KEY]: {
        [TicketSystemFieldsKeyMap.emailCc]: null,
        [TicketSystemFieldsKeyMap.status]: reverseStatusMap.New,
        [TicketSystemFieldsKeyMap.subject]: null,
        [TicketSystemFieldsKeyMap.requester]: null,
        [TicketSystemFieldsKeyMap.assignee]: null,
        [TicketSystemFieldsKeyMap.formId]: null
    }
};

export const endUserRequestFormDefaultValues: Omit<EndUserRequestFormValues, 'formName'> = {
    comment: {
        body: null,
        channel: channelTypeMap.USER_FORM,
        creator: [
            {
                key: 'us.email',
                value: null
            }
        ],
        publicVisible: publicVisibleToBooleanConverter(PublicVisibleTypeMap.public)
    },
    currentAttachments: { inlineImages: [], attachments: [] },
    [TICKET_FORM_FIELDS_KEY]: {
        [TicketSystemFieldsKeyMap.subject]: null,
        [TicketSystemFieldsKeyMap.attachments]: null,
        [TicketSystemFieldsKeyMap.formId]: null
    }
};
